import { renderInputsOfAudioNode } from '../helpers/render-inputs-of-audio-node';
export const createAudioDestinationNodeRenderer = () => {
    let nativeAudioDestinationNodePromise = null;
    const createAudioDestinationNode = async (proxy, nativeOfflineAudioContext) => {
        const nativeAudioDestinationNode = nativeOfflineAudioContext.destination;
        await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAudioDestinationNode);
        return nativeAudioDestinationNode;
    };
    return {
        render(proxy, nativeOfflineAudioContext) {
            if (nativeAudioDestinationNodePromise === null) {
                nativeAudioDestinationNodePromise = createAudioDestinationNode(proxy, nativeOfflineAudioContext);
            }
            return nativeAudioDestinationNodePromise;
        }
    };
};
//# sourceMappingURL=/build/es2018/factories/audio-destination-node-renderer-factory.js.map